/**
 * 工具类
 */
import CryptoJS from "crypto-js";
import { YEK_SEA } from "@/config/comm"

const API_ENCRYPT_WHITE = ["currency-ui/", "editor-app/", "auth/token", "authApi","fileRelation/saveFile"]

export const utils = {
    filePreviewFormat:['xls','xlsx','docx','doc','pptx','ppt','txt','pdf','png','jpg','jpeg'],//附件在线预览格式
    pictureFormat:['gif','png','jpg'],
    fileFormat: ["doc", "docx", "txt", "xls", "xlsx", "ppt", "pptx", "pdf","png","jpg","jpeg"],
    /**
     * md5 加密方法
     * @param str
     * @returns {*}
     */
    md5: str => {
        return CryptoJS.MD5(str).toString();
    },


    /**
     * 判断是否json字符串
     * @param { } str
     * @returns
     */
    isJSON: (str) => {
        if (typeof str == 'string') {
            try {
                JSON.parse(str);
                return true;
            } catch (e) {
                return false;
            }
        }
    },
    /**
     * 处理url参数加密
     * @param {*} url
     */
    buildUrl: (url) => {
        let params = {}, tempArr = [];
        tempArr = url.split("?")[1].split("&");
        tempArr.map(v => (params[v.split("=")[0]] = v.split("=")[1]));
        if (params) {
            params = utils.encryptParam(params);
            let path = url.split("?")[0] + "?";
            for (var k in params) {
                path += ((path.indexOf("=") != -1) ? "&" : "") + k + "=" + encodeURIComponent(params[k]);
            }
            url = path;
        }
        return url;
    },
    /**
     * 过滤白名单的地址
     * @param url
     * @returns
     */
    isExclude: (url) => {
        let flag = false
        for (let item of API_ENCRYPT_WHITE) {
            if (url.indexOf(item) > -1) {
                flag = true;
                break;
            }
            if (item.indexOf("*") > -1) {
                let isExist = false;
                let arr = item.split("*")
                for (let str of arr) {
                    if (url.indexOf(str) > -1) {
                        isExist = true
                    } else {
                        isExist = false
                        break
                    }
                }
                if (isExist)
                    flag = true
            }
        }
        return flag;
    },

    /**
     * AES加密方法
     * @param text
     * @returns {string}
     */
    encryptText: (text) => {
        let key = CryptoJS.enc.Utf8.parse(YEK_SEA);
        let readyText = CryptoJS.enc.Utf8.parse(text);
        let encryptedText = CryptoJS.AES.encrypt(readyText, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return encryptedText.toString();
    },
    /**
     * AES 解密方法
     * @param text
     * @returns {*}
     */
    decryptText: (text) => {
        if (!text) return ''
        let key = CryptoJS.enc.Utf8.parse(YEK_SEA);
        let decryptText = CryptoJS.AES.decrypt(text, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return CryptoJS.enc.Utf8.stringify(decryptText).toString();
    },
    /**
     * AES 解密方法
     * @param text
     * @param seaKey
     * @returns {*}
     */
    decryptTextByKey: (text, seaKey) => {
        if (!text) return ''
        let key = CryptoJS.enc.Utf8.parse(seaKey);
        let decryptText = CryptoJS.AES.decrypt(text, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        return CryptoJS.enc.Utf8.stringify(decryptText).toString();
    },

    /**
     * 加密各参数
     * @param text
     */
    encryptParam: (param) => {
        let obj={};
        for(let prop in param) {
            if(param[prop] || param[prop] ===0 ){
                if(param[prop].length===0){
                    obj[prop]= '';
                }else{
                    obj[prop]= utils.encryptText(param[prop].toString());
                }
            }else{
                obj[prop]= '';
            }
        }
        return obj;
    },

    /**
     * 获取 12 位行政区划等级
     * @param areaCode
     * @returns {number}
     */
    getLevel: areaCode => {
        if (!areaCode) return 0;
        let length = getVaildCode(areaCode).length;
        let level = 1;
        if (length > 0 && length <= 2) {
            //省级
            level = 1;
        } else if (length > 2 && length <= 4) {
            //市级
            level = 2;
        } else if (length > 4 && length <= 6) {
            //县级
            level = 3;
        } else if (length > 6 && length <= 9) {
            //乡级
            level = 4;
        } else if (length > 9 && length <= 12) {
            //村级
            level = 5;
        }
        return level;
    },
    /**
     * 根据行政区划等级填充 12 位行政区划编码
     * @param code
     * @returns {string}
     */
    fillCode: code => {
        let level = utils.getLevel(code);
        switch (level) {
            case 1:
                code = code + "0000000000";
                break;
            case 2:
                code = code + "00000000";
                break;
            case 3:
                code = code + "000000";
                break;
            case 4:
                code = code + "000";
                break;
            case 5:
                break;
        }
        return code;
    },
    /**
     * 计算某元素的偏移量
     * @param target
     * @returns {{top: *, left: *}}
     */
    offset: target => {
        let top = 0,
            left = 0;
        while (target.offsetParent) {
            top += target.offsetTop;
            left += target.offsetLeft;
            target = target.offsetParent;
        }
        return {
            top: top,
            left: left
        };
    },
    /**
     * 判断浏览器时候缩放 ratio != 100 表示进行了缩放
     * @returns {number}
     */
    detectZoom: () => {
        var ratio = 0,
            screen = window.screen,
            ua = navigator.userAgent.toLowerCase();
        if (window.devicePixelRatio !== undefined) {
            ratio = window.devicePixelRatio;
        } else if (~ua.indexOf("msie")) {
            if (screen.deviceXDPI && screen.logicalXDPI) {
                ratio = screen.deviceXDPI / screen.logicalXDPI;
            }
        } else if (
            window.outerWidth !== undefined &&
            window.innerWidth !== undefined
        ) {
            ratio = window.outerWidth / window.innerWidth;
        }
        if (ratio) {
            ratio = Math.round(ratio * 100);
        }
        return ratio;
    },
    /**
     * 数字转动效果，基于 jQuery
     * @param $
     * @param selector
     * @param point
     */
    numberAnimate: function($, selector, point) {
        $(selector).each(function() {
            $(this)
                .prop("Counter", 0)
                .animate(
                    {
                        Counter: $(this).text()
                    },
                    {
                        duration: 1000,
                        easing: "swing",
                        step: function(now) {
                            if (
                                !!now &&
                                !isNaN(now) &&
                                now.toString().indexOf(".") > 0
                            ) {
                                now = Number(now).toFixed(point);
                            }
                            $(this).text(now);
                        }
                    }
                );
        });
    },
    /**
     * 将数字转换为带单位的字符串
     * @param {Number} num 要转换的数字
     * @param {Number} point 保留极为小数
     * @return {Object} obj.res 转换后的结果， obj.unit 转换后的单位
     */
    toHasUnitString: (num = 0, point = 2) => {
        var obj = {};
        num = Number(num);
        if (num >= 100000000) {
            obj.data = (num / 100000000).toFixed(point);
            obj.unit = "亿";
        } else if (100000000 > num && num >= 10000) {
            obj.data = (num / 10000).toFixed(point);
            obj.unit = "万";
        } else {
            if (!!num && !isNaN(num) && num.toString().indexOf(".") > 0) {
                num = Number(num).toFixed(point);
            }
            obj.data = num;
            obj.unit = "";
        }

        return {
            ...obj,
            data: obj.data
        };
    },
    //格式化字节大小
    formatMb: (bytes = 0, point = 2) => {
        if (bytes === 0) return {value: 0, unit: 'B'};
        var unitArr = new Array("Bytes","KB","MB","GB","TB","PB","EB","ZB","YB");
        var k = 1024, // or 1024
            index = 0,
            srcsize = parseFloat(bytes);
            index = Math.floor(Math.log(srcsize)/Math.log(k));

        var size = srcsize / Math.pow(k, index)
        return {
            value: size.toFixed(point),
            unit: unitArr[index]
        }
    },
    /**
     * 时间格式化方法
     * @param date
     * @param fmt
     * @returns {*}
     */
    dateFormat: (date, fmt) => {
        var o = {
            "M+": date.getMonth() + 1, //月份
            "d+": date.getDate(), //日
            "H+": date.getHours(), //小时
            "m+": date.getMinutes(), //分
            "s+": date.getSeconds(), //秒
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度
            S: date.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(
                RegExp.$1,
                (date.getFullYear() + "").substr(4 - RegExp.$1.length)
            );
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(
                    RegExp.$1,
                    RegExp.$1.length == 1
                        ? o[k]
                        : ("00" + o[k]).substr(("" + o[k]).length)
                );
        return fmt;
    },
    computeUtil: (value1, symbol, value2) => {
        if (!value1) {
            return false;
        }
        let b = false;
        if (!isNaN(value1) && !isNaN(value2)) {
            b = eval(`${value1}${symbol}${value2}`);
        } else {
            switch (symbol) {
                case "==":
                    b = value1 === value2;
                    break;
                case "!=":
                    b = value1 !== value2;
                    break;
                default:
                    b = false;
                    break;
            }
        }
        return b;
    },
    // 身份证、电话脱敏
    handleNo(val){
        if (val != '' && val != null) {
            if (val.length == 11) {
                return val.substring(-1, 3) + '****' + val.substring(val.length - 4, val.length)
            } else if (val.length == 18) {
                return val.substring(-1, 6) + '********' + val.substring(val.length - 4, val.length)
            } else if (val.length == 12) {
                return val.substring(-1, 4) + '****' + val.substring(val.length - 4, val.length)
            } else if (val.length == 7) {
                return val.substring(-1, 2) + '***' + val.substring(val.length - 2, val.length)
            } else if (val.length == 19){
              return val.substring(-1, 6) + '********' + val.substring(val.length - 5, val.length)
            }
        }else{
            return val;
        }
    },
    //获取系统当前时间
    getNowTime(){
        var _this = this;
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth()+1 <10 ? '0'+(new Date().getMonth()+1):new Date().getMonth()+1;
        let dd = new Date().getDate()<10 ? '0'+new Date().getDate() :new Date().getDate();
        let hh = new Date().getHours()<10 ? '0'+new Date().getHours() :new Date().getHours();
        let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
        let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
        _this.gettime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf+':'+ss;
        return _this.gettime;
    },

    //获取系统当前时间
    getMonth(){
        var _this = this;
        let yy = new Date().getFullYear();
        let mm = new Date().getMonth()+1 <10 ? '0'+(new Date().getMonth()+1):new Date().getMonth()+1;
        let dd = new Date().getDate()<10 ? '0'+new Date().getDate() :new Date().getDate();
        _this.gettime = yy+'-'+mm+'-'+dd;
        return _this.gettime;
    },

    // 数据排序
    compare(property, orderType){
        return function(a,b){
            var value1 = a[property];
            var value2 = b[property];
            if(orderType == 'asc'){
                return value1 - value2;
            }else{
                return value2 - value1;
            }
        }
    },

    // 数据分组
    arrayGroupBy(list, groupId) {
        const sorted = groupBy(list, function (item) {
            return [item[groupId]]
        })
        return sorted
    },

};

function getVaildCode(code) {
    let arr = code.split("").reverse();
    let c = 0;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] != "0") {
            c = i;
            break;
        }
    }
    return code.substring(0, 12 - c);
}

// 数据分组
function groupBy(array, f){
    const groups = {}
        array.forEach(function (o) {
        const group = JSON.stringify(f(o))
        groups[group] = groups[group] || []
        groups[group].push(o)
    })
    return Object.keys(groups).map(function (group) {
        return groups[group]
    })
}

export const uuid = function(){
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
        return r.toString(16)
    }).replace(/-/g, '');
}
